<template>
    <v-container class="pa-0 mx-0">
    <v-divider />
    <v-row dense class="ma-0 px-1">
        <v-col cols="3" v-if="!hide_label" class="body-1 font-italic">
            <v-sheet><div class="d-flex"><slot name="label">{{ label }}</slot></div>
            <div class="caption ml-2 ">
            <slot name="details"></slot>
            </div></v-sheet>
        </v-col>
        <v-col>
            <v-sheet>
            <div class="d-flex font-weight-bold" v-if="value"><slot name="value">{{ value }}</slot><br/></div>
            <div class="d-flex caption"><slot></slot></div>
            </v-sheet>
        </v-col>
    </v-row>
    </v-container>
</template>

<script>
export default {
    props: ['label', 'value', 'hide_label'],
}
</script>

<style>

</style>
